import React, { useEffect } from 'react'
import scrollToTop from '../helpers/scrollToTop'
import bannerImage from '../images/banner-image.jpg'
import maria from '../images/maria.jpg'
import lara from '../images/lara.jpg'
import elas from '../images/elas.jpg'

function About() {
  useEffect(() => {
    scrollToTop()
  },[])
  
  return (
    <div className='min-h-screen bg-[#F5F1E9]'>
      {/* Hero Section */}
      <div className='relative'>
        <img 
          className='object-cover h-[22vh] min-h-[140px] sm:h-[26vh] md:h-[30vh] w-full' 
          src={bannerImage}
          alt="Ambiente acolhedor do Beauty Space"
        />
        <div className='absolute inset-0 bg-gradient-to-b from-[#c0a080]/40 to-[#c0a080]/70'></div>
        <div className="absolute inset-0 flex items-center justify-center">
          <h2 className="text-[#F5F1E9] text-center px-6 text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-light text-balance tracking-wide">
            Oops! Página não encontrada.
          </h2>
        </div>
        
        {/* Wave shape at the bottom - Refinada */}
        <div className="absolute bottom-0 left-0 w-full h-16">
          <svg viewBox="0 0 1200 60" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" className="w-full h-full">
            <path d="M0,60 V30 C150,50 350,40 500,35 C650,30 750,25 900,30 C1050,35 1200,45 1200,45 V60 H0 Z" fill="#F5F1E9"/>
          </svg>
        </div>
      </div>

      {/* Content Section */}
      <div className='max-w-6xl mx-auto px-4 py-12'>
        <p className='text-center text-gray-700 mb-8'>
          A página que procuras não foi encontrada. Talvez tenha sido movida ou excluída.
        </p>
        <div className='text-center'>
          <a 
            href='/' 
            className='inline-block bg-[#c0a080] text-white px-6 py-3 rounded-full shadow hover:bg-[#a88770] transition duration-300'
          >
            Voltar para a Página Inicial
          </a>
        </div>
      </div>  
    </div>
  )
}

export default About